import { render, staticRenderFns } from "./DiscussionFlag.vue?vue&type=template&id=2fb1b5dd&scoped=true"
import script from "./DiscussionFlag.vue?vue&type=script&lang=ts"
export * from "./DiscussionFlag.vue?vue&type=script&lang=ts"
import style0 from "./DiscussionFlag.vue?vue&type=style&index=0&id=2fb1b5dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb1b5dd",
  null
  
)

export default component.exports